// @flow

const Colors = {
  // zuzu colors
  Primary: '#da6e54',
  Profile: '#88bebc',
  Feedback: '#b383be',
  Comment: '#80bbff',
  Background: '#eae4e1',
  WIP: '#ff00ff',
  Text: '#444444',
  Error: '#d0021b',
  Facebook: '#3b5998',
  Whatsapp: '#4dc247',
  Drawer: '#333333',
  DirtyWhite: '#eeeeee',

  // basic
  White: '#ffffff',
  Black: '#000000',
  Blue: '#80bbff',
  Green: '#aac755',
  Yellow: '#ffc900',
  Orange: '#f0b34e',
  LightGrey: '#aaaaaa',
  DarkGrey: '#dddddd',
};
const STATE_COLORS = {
  new: Colors.Blue,
  'in-progress': Colors.Orange,
  pending: Colors.Orange,
  finished: Colors.Green,
  declined: Colors.Error,
  deleted: Colors.Error,
};

const Sizes = {
  YourPenis: 4,
  Nano: 8,
  Micro: 16,
  Small: 24,
  Medium: 32,
  Large: 48,
  Giga: 64,
  YourMum: 128,
};

const Spacing = Sizes;
export { Colors, STATE_COLORS, Sizes, Spacing };



// WEBPACK FOOTER //
// ./src/utils/styleguide.js